<template>
  <div id="app">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <settings :user="user" v-if="Object.keys(user).length > 0"/>
            <div class="col-3" id="logo-container">
              <img  alt="oro logo" id="logo" src="./assets/logo.png" @click="goHome()">
            </div>
        </div>
      </div>

    </div>
    <transition
      enter-active-class="swing-in-bottom-fwd"
      leave-active-class="swing-out-bottom-bck"
      >
      <modal :data="modalInfo" v-if="modalInfo"></modal>
      <imagemodal :data="imageModalInfo" v-if="imageModalInfo"></imagemodal>
    </transition>
    <maintenance v-if="maintenance && !Object.keys(user).length > 0 && !['login', 'FAQ'].includes(this.$route.name)"/>
    <router-view v-else></router-view>
    <Footer></Footer>
    <navigation></navigation>
  </div>
</template>

<script>
import Settings from './components/admin/Settings.vue'
import Modal from './components/Modal.vue'
import ImageModal from './components/ImageModal.vue'
import Navigation from './components/Navigation.vue'
import Footer from './components/Footer.vue'
import Helper from './components/mixins/HelperFunctions.js'
import Maintenance from './components/Maintenance.vue'
import {systemRef} from './firebase/firebaseConfig'
export default {
  name: 'App',
  mixins: [Helper],
  components: {
    settings: Settings,
    modal: Modal,
    imagemodal: ImageModal,
    navigation: Navigation,
    Footer: Footer,
    Maintenance: Maintenance
  },
  mounted(){
    this.updateLastVisitor()
  },
  data: function () {
    return {
      toggle: false
    }
  },
  computed: {
    maintenance () {
      return this.$store.getters.getSystem.maintenance
    },
    user () {
      return this.$store.getters.getUser
    },
    modalInfo () {
      return this.$store.getters.getModal
    },
    imageModalInfo () {
      return this.$store.getters.getImageModal
    }
  },
  methods: {
    updateLastVisitor() {
      systemRef.doc('visitor').update(
        {lastVisitor: new Date()}
      ).then(() => {
      }).catch(function(error) {
        console.log('error', error)
      })
    },
    getReservationSession(){

    },
    goHome() {
      if (Object.keys(this.user).length > 0 && this.$router.currentRoute.name !== 'admin') {
        this.$router.push({name: 'admin'})
      }
    }
  }
}
</script>
<style lang="scss">
  @import './styles/simple-grid.scss'
</style>
<style>
html {
background: $oroGray;
}

input {
  display: inline-block;
  width: 100%;
  padding: 15px 0;
  border: none;
  outline: none;
  font-size: 24px;
  &:focus {
    border: none;
    color: #772e25;
  }
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: $oroGray;
  padding-bottom: 50px;
}
img#logo {
  height: 40px;
  float: left;
}
.container {
}
.button {
  cursor: pointer;
}
</style>

<style lang="scss">
.swing-out-bottom-bck {
	-webkit-animation: swing-out-bottom-bck 0.45s cubic-bezier(0.600, -0.280, 0.735, 0.045) both;
  animation: swing-out-bottom-bck 0.45s cubic-bezier(0.600, -0.280, 0.735, 0.045) both;
}
/* ----------------------------------------------
 * Generated by Animista on 2020-5-21 22:46:11
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation swing-out-bottom-bck
 * ----------------------------------------
 */
@-webkit-keyframes swing-out-bottom-bck {
  0% {
    -webkit-transform: rotateX(0);
            transform: rotateX(0);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    opacity: 1;
  }
  100% {
    -webkit-transform: rotateX(100deg);
            transform: rotateX(100deg);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    opacity: 0;
  }
}
@keyframes swing-out-bottom-bck {
  0% {
    -webkit-transform: rotateX(0);
            transform: rotateX(0);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    opacity: 1;
  }
  100% {
    -webkit-transform: rotateX(100deg);
            transform: rotateX(100deg);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    opacity: 0;
  }
}

.swing-in-bottom-fwd {
	-webkit-animation: swing-in-bottom-fwd 0.5s cubic-bezier(0.175, 0.885, 0.320, 1.275) both;
  animation: swing-in-bottom-fwd 0.5s cubic-bezier(0.175, 0.885, 0.320, 1.275) both;
}

/* ----------------------------------------------
 * Generated by Animista on 2020-5-21 22:43:40
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation swing-in-bottom-fwd
 * ----------------------------------------
 */
@-webkit-keyframes swing-in-bottom-fwd {
  0% {
    -webkit-transform: rotateX(100deg);
            transform: rotateX(100deg);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    opacity: 0;
  }
  100% {
    -webkit-transform: rotateX(0);
            transform: rotateX(0);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    opacity: 1;
  }
}
@keyframes swing-in-bottom-fwd {
  0% {
    -webkit-transform: rotateX(100deg);
            transform: rotateX(100deg);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    opacity: 0;
  }
  100% {
    -webkit-transform: rotateX(0);
            transform: rotateX(0);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    opacity: 1;
  }
}


@keyframes flipInX {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }

  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }

  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }

  to {
    transform: perspective(400px);
  }
}

.flipInX-enter-active {
  backface-visibility: visible !important;
  animation-name: flipInX;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.swing-in-top-fwd {
	-webkit-animation: swing-in-top-fwd 0.5s cubic-bezier(0.175, 0.885, 0.320, 1.275) both;
  animation: swing-in-top-fwd 0.5s cubic-bezier(0.175, 0.885, 0.320, 1.275) both;
}
.swing-out-bottom-bck {
	-webkit-animation: swing-out-bottom-bck .6s cubic-bezier(0.600, -0.280, 0.735, 0.045) both;
  animation: swing-out-bottom-bck .6s cubic-bezier(0.600, -0.280, 0.735, 0.045) both;
}
/* ----------------------------------------------
 * Generated by Animista on 2020-5-17 22:11:52
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation swing-out-bottom-bck
 * ----------------------------------------
 */
@-webkit-keyframes swing-out-bottom-bck {
  0% {
    -webkit-transform: rotateX(0);
            transform: rotateX(0);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    opacity: 1;
  }
  100% {
    -webkit-transform: rotateX(100deg);
            transform: rotateX(100deg);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    opacity: 0;
  }
}
@keyframes swing-out-bottom-bck {
  0% {
    -webkit-transform: rotateX(0);
            transform: rotateX(0);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    opacity: 1;
  }
  100% {
    -webkit-transform: rotateX(100deg);
            transform: rotateX(100deg);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    opacity: 0;
  }
}

/* ----------------------------------------------
 * Generated by Animista on 2020-5-17 22:4:17
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation swing-in-top-fwd
 * ----------------------------------------
 */
@-webkit-keyframes swing-in-top-fwd {
  0% {
    -webkit-transform: rotateX(-100deg);
            transform: rotateX(-100deg);
    -webkit-transform-origin: top;
            transform-origin: top;
    opacity: 0;
  }
  100% {
    -webkit-transform: rotateX(0deg);
            transform: rotateX(0deg);
    -webkit-transform-origin: top;
            transform-origin: top;
    opacity: 1;
  }
}
@keyframes swing-in-top-fwd {
  0% {
    -webkit-transform: rotateX(-100deg);
            transform: rotateX(-100deg);
    -webkit-transform-origin: top;
            transform-origin: top;
    opacity: 0;
  }
  100% {
    -webkit-transform: rotateX(0deg);
            transform: rotateX(0deg);
    -webkit-transform-origin: top;
            transform-origin: top;
    opacity: 1;
  }
}

</style>
